/*
	import { listVirtualMeetings } from '@/services/BoardMeetings/VirtualMeeting/List';

  const { virtualMeetings } = await listPhysicalMeetings ({
    params: {
			hoaID
    }
  });
*/

import _get from 'lodash/get'
import kms from '@/services/kms'
import { notifyError } from '@/services/notify'

export async function listVirtualMeetings({ params }) {
  let message = 'The virtual meetings list could not be retrieved.'

  try {
    const result = await kms.get(`/BoardMeetings/VirtualMeeting/List`, {
      params: {
        hoaID: params.hoaID
      }
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      message: '',
      virtualMeetings: list
    }
  } catch (exception) {
    console.error(exception)
  }

  notifyError(message)

  return {
    successful: false,
    message,
    virtualMeetings: []
  }
}
